export default __webpack_public_path__ + "static/media/html.9d7930cb.png";